import React from 'react'
import { Box, Paper, Skeleton } from '@mui/material'

const FareCards = () => {
    return (
        <Box sx={{ mt: 2.5 }}>
            <Skeleton variant="text" width={140} height={28} sx={{ mb: 2 }} />
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: '1fr',
                        lg: 'repeat(3, 1fr)'
                    },
                    gap: 1.5,
                    alignItems: 'stretch'
                }}
            >
                {[...Array(3)].map((_, index) => (
                    <Paper
                        key={index}
                        elevation={0}
                        sx={{
                            border: '1px solid',
                            borderColor: 'borders.default',
                            borderRadius: 2,
                            height: '164px',
                            p: 2,
                            position: 'relative'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                mb: 2
                            }}
                        >
                            <Box>
                                <Skeleton variant="text" width={80} height={20} />
                                <Skeleton variant="text" width={60} height={16} sx={{ mt: 0.5 }} />
                            </Box>
                            <Skeleton variant="text" width={60} height={24} />
                        </Box>
                        <Box sx={{ space: 1 }}>
                            <Skeleton variant="text" width="100%" height={14} />
                            <Skeleton variant="text" width="80%" height={14} />
                            <Skeleton variant="text" width="90%" height={14} />
                        </Box>
                    </Paper>
                ))}
            </Box>
        </Box>
    )
}

export default FareCards
